export default __webpack_public_path__ + "static/media/tools.dfa38204.svg";